const base = process.env.PUBLIC_URL || "";

export const assetPath = (filename) => `${base}/assets/${filename}`;

export const assets = {
  logo: assetPath("logo.png"),
  heroBg: assetPath("hero-bg.jpg"),
  aboutLab: assetPath("about-lab.jpg"),
  whyPartnerFactory: assetPath("factory.jpg"),
  qualityLab: assetPath("quality-lab.jpg"),
};
